var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "main-container",
    attrs: {
      "height": "100%"
    }
  }, [_c('v-img', {
    staticClass: "hero-image",
    style: {
      height: ("calc(100vh - " + (_vm.$vuetify.application.top) + "px + 100px)"),
      top: '50px'
    },
    attrs: {
      "cover": "",
      "position": "center center",
      "src": "https://media.eipl.org/site/images/building/second-floor.jpg"
    }
  }), _c('page-header', {
    attrs: {
      "autoHide": false,
      "backgroundColor": "#c5bdbb",
      "chipItems": _vm.chipItems,
      "titleText": "ABOUT US",
      "titleColor": _vm.$vuetify.theme.themes.light.primary
    },
    on: {
      "input": _vm.onChipChange
    },
    model: {
      value: _vm.chipItemSelected,
      callback: function ($$v) {
        _vm.chipItemSelected = $$v;
      },
      expression: "chipItemSelected"
    }
  }), _c('v-container', {
    staticClass: "d-flex flex-column transparent align-center px-4",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-row', {
    attrs: {
      "align": "start",
      "align-contet": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-flex justify-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mission-statement",
    attrs: {
      "color": "#FFFFFFDB",
      "max-width": "800",
      "outlined": "",
      "width": "100%"
    }
  }, [_c('v-card-title', {
    staticClass: "primary--text text-h5 font-weight-bold"
  }, [_vm._v("Our Mission Statement")]), _c('v-card-text', {
    staticClass: "primary--text font-weight-bold"
  }, [_c('p', [_vm._v(" The Staff and Trustees of the East Islip Public Library are dedicated to serving the educational cultural and intellectual needs of the communities of East Islip, Islip Terrace and Great River. ")]), _c('p', [_c('em', [_vm._v("-Adapted: December 15, 1992")])])])], 1)], 1), _c('v-col', {
    staticClass: "d-flex justify-center mt-10",
    attrs: {
      "cols": "12"
    }
  }, [_c('hours-card', {
    attrs: {
      "id": "hours"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex justify-center mt-10",
    attrs: {
      "cols": "12"
    }
  }, [_c('directions-card', {
    attrs: {
      "id": "location"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex justify-center mt-10",
    attrs: {
      "cols": "12"
    }
  }, [_c('contact-card', {
    attrs: {
      "id": "contact"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex justify-center mt-10",
    attrs: {
      "cols": "12"
    }
  }, [_c('material-periods-fines-card', {
    attrs: {
      "id": "material"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex justify-center mt-10",
    attrs: {
      "cols": "12"
    }
  }, [_c('policies-card', {
    attrs: {
      "id": "policies"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex justify-center mt-10",
    attrs: {
      "cols": "12"
    }
  }, [_c('board-schedule-card')], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }